export class Fechas_importantes{
    fecha:string;
    descripcion_fecha:string;
}